<div class="thank-you-container">
  <div class="thank-you-additional-messages-final">
    <h2>
      {{ 'Thanks a lot, we wish you a pleasant day.' | translate }}
    </h2>
  </div>
</div>
